module.exports = __webpack_public_path__ + "static/media/mobileHeaderLogo.7ce4036c.png";